// core version + navigation, pagination modules:
import Swiper, { Pagination } from 'swiper';

// configure Swiper to use modules
//Swiper.use([Pagination]);

const testimoniesSlider = {
    ui: {},

    init: function() {
        this.bindUI();
        this.bindEvents();
        this.bindSlider();
    },

    bindUI: function() {
        this.ui.testimoniesSliders = document.querySelectorAll(".js-testimoniesSlider");
    },

    bindEvents: function() {},

    bindSlider: function() {
        this.ui.testimoniesSliders.forEach(slider => {
            const swiperInst = new Swiper(slider, {
                autoHeight: true,
                slidesPerView: 1,
                spaceBetween: 100,
                containerModifierClass: 'js-testimoniesSlider',
                wrapperClass: 'js-testimoniesSlider-wrapper',
                slideClass: 'js-testimoniesSlider-slide',
                modules: [Pagination],
                pagination: {
                    el: '.js-testimoniesSlider-pagination',
                    clickable: true
                },
            });
        });
    },
};

export default testimoniesSlider;